import React from "react";
import { insertImage$, TooltipWrap, useTranslation } from "@mdxeditor/editor";
import { usePublisher } from "@mdxeditor/gurx";

export const ImageUploadComponent = ({
  imageUploadHandler,
}: {
  imageUploadHandler: (file: File) => Promise<string>;
}) => {
  const insertImage = usePublisher(insertImage$);
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const t = useTranslation();
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    Array.from(e.target.files || []).forEach((file) => {
      imageUploadHandler(file).then((url) => {
        insertImage({
          src: url,
          altText: file.name,
          title: file.name,
        });
      });
    });
  };
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
        type="file"
        style={{ display: "none" }}
        ref={fileInputRef}
        multiple
        onChange={handleFileChange}
      />
      <button
        type="button"
        aria-label="Insert image"
        tabIndex={-1}
        data-orientation="horizontal"
        data-radix-collection-item=""
        onClick={handleButtonClick}
        className={"toolbar-button"}
      >
        <TooltipWrap title={t("toolbar.image", "Insert image")}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.11537 20.5C4.6182 20.5 4.19262 20.323 3.83862 19.969C3.48462 19.615 3.30762 19.1894 3.30762 18.6922V5.30773C3.30762 4.81056 3.48462 4.38498 3.83862 4.03098C4.19262 3.67698 4.6182 3.49998 5.11537 3.49998H13.8076V4.99998H5.11537C5.02553 4.99998 4.95178 5.02881 4.89412 5.08648C4.83645 5.14415 4.80762 5.2179 4.80762 5.30773V18.6922C4.80762 18.7821 4.83645 18.8558 4.89412 18.9135C4.95178 18.9711 5.02553 19 5.11537 19H18.4999C18.5895 19 18.6633 18.9711 18.7211 18.9135C18.7788 18.8558 18.8076 18.7821 18.8076 18.6922V9.99998H20.3076V18.6922C20.3076 19.1894 20.1306 19.615 19.7766 19.969C19.4226 20.323 18.997 20.5 18.4999 20.5H5.11537ZM17.1921 8.61523V6.61523H15.1921V5.11548H17.1921V3.11548H18.6921V5.11548H20.6921V6.61523H18.6921V8.61523H17.1921ZM6.55762 16.75H17.1344L13.8459 12.3655L11.0384 16.0192L9.03837 13.4615L6.55762 16.75Z"
              fill="currentColor"
            />
          </svg>
        </TooltipWrap>
      </button>
    </>
  );
};
